// Mint-TMS-iPad (page=detail) · dữ liệu mẫu theo script board: T0, STEP, trProps, trSteps, trPic. Không có tiền (money=hide).
export const IPAD_STEPS = ['Đi lấy cont', 'Tại depot', 'Đến kho', 'Rời kho', 'Về cảng', 'Hạ cont', 'Xong'] as const;
const AT = ['07:12', '07:40', '09:05', '11:20', '13:02', '', ''] as const;

// [mã, xe, tài xế, job, cont, bước hiện tại, hạn, rủi ro, điều độ]
type Row = readonly [string, string, string, string, string, number, string, 'p0' | 'late' | 'ok' | 'done', string];
const T0: readonly Row[] = [
  ['TR-2610-0315', '51C-903.55', 'Trần Văn Hải', 'HANA-SE-2610-0130', '1×40RF', 3, 'CY Cái Mép 17:00', 'p0', 'THANH'],
  ['TR-2610-0316', '51D-221.09', 'Ngô Văn Thắng', 'HANA-SI-2610-0088', '1×20DC', 5, 'Giao 14:00', 'late', 'THANH'],
  ['TR-2610-0311', '51C-628.14', 'Nguyễn Văn Công', 'HANA-SE-2610-0142', '1×40HC', 4, 'CY Cát Lái 15:00', 'ok', 'THANH'],
  ['TR-2610-0312', '51D-140.77', 'Lê Minh Định', 'HANA-SE-2610-0139', '1×40HC', 2, 'CY Cát Lái 15:00', 'ok', 'THANH'],
  ['TR-2610-0318', '51C-377.40', 'Phạm Minh Tuấn', 'HANA-SE-2610-0127', '2×20DC', 1, 'CY Cát Lái 19:00', 'ok', 'PHONG'],
  ['TR-2610-0320', 'Nhà xe Quỳnh Vy', '51C-771.20', 'HANA-SE-2610-0118', '1×40HC', 2, 'CY Cát Lái 21:00', 'ok', 'THANH'],
  ['TR-2610-0321', '51C-118.62', 'Trần Thảo', 'HANA-TR-2610-0044', '2×20DC', 0, 'Lấy cont 13:30', 'ok', 'THANH'],
  ['TR-2610-0319', '51D-512.83', 'Võ Kim Nguyên', 'HANA-SE-2610-0121', '1×40HC', 6, 'Xong 10:42', 'done', 'THANH'],
];

export interface IpadStep { k: string; at: string; kind: 'done' | 'cur' | 'next'; late: boolean; last: boolean }
export interface IpadDetail {
  id: string; job: string; disp: string; status: string; p0: boolean;
  props: Array<{ k: string; v: string }>;
  steps: IpadStep[];
  pic: Array<{ k: string; s: string; ini: string }>;
}

export function ipadDetail(id: string | undefined, truckOverride?: string): IpadDetail {
  const row = T0.find((x) => x[0] === id) ?? T0[0]!;
  const si = row[5];
  const p0 = row[7] === 'p0';
  const driver = row[2];
  const props = [
    { k: 'Xe', v: truckOverride ?? row[1] }, { k: 'Tài xế', v: driver }, { k: 'Cont', v: row[4] }, { k: 'Hạn', v: row[6] },
    { k: 'Km GPS', v: '34,2 km' }, { k: 'Nhiệt độ', v: p0 ? '−14 °C (đặt −18)' : '—' },
  ];
  const steps: IpadStep[] = IPAD_STEPS.map((k, j) => ({
    k, last: j === IPAD_STEPS.length - 1, late: j === si && p0,
    at: j < si ? AT[j]! : j === si ? 'đang' : 'dự kiến',
    kind: j < si ? 'done' : j === si ? 'cur' : 'next',
  }));
  const ini = (n: string) => n.trim().split(/\s+/).slice(-1)[0]!.slice(0, 2).toUpperCase();
  return {
    id: row[0], job: row[3], disp: row[8], status: si === 6 ? 'Xong' : IPAD_STEPS[si]!, p0, props, steps,
    pic: [{ k: row[8], s: 'Điều độ · được giao', ini: ini(row[8]) }, { k: driver, s: 'Tài xế · được giao', ini: ini(driver) }],
  };
}
